import type { SVGProps } from 'react'
const LineGenerateImage = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M17.25 2h1.5c0 1.79 1.46 3.25 3.25 3.25v1.5c-1.79 0-3.25 1.46-3.25 3.25h-1.5c0-1.79-1.46-3.25-3.25-3.25v-1.5c1.79 0 3.25-1.46 3.25-3.25m-.7 4c.585.375 1.08.87 1.45 1.45.375-.585.87-1.08 1.45-1.45A4.8 4.8 0 0 1 18 4.55 4.8 4.8 0 0 1 16.55 6m-.935 5.325L11.5 15.44l-1.365-1.365a1.26 1.26 0 0 0-1.77 0L4.5 17.94V5.75c0-.69.56-1.25 1.25-1.25h6.75V3H5.75A2.755 2.755 0 0 0 3 5.75v12.5A2.755 2.755 0 0 0 5.75 21h12.5A2.755 2.755 0 0 0 21 18.25v-3.31l-3.615-3.615a1.26 1.26 0 0 0-1.77 0M19.5 18.25c0 .69-.56 1.25-1.25 1.25H5.75c-.2 0-.39-.045-.56-.13l4.06-4.06 2.25 2.25 5-5 3 3zM6 8.5a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0m3.5 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineGenerateImage }
